import { SelectOption } from '@/features/editMode/types/selectOption';

export const findOptionByLookup = (options: SelectOption[], lookup: string) => {
  return options.find((option) => option.metadata?.lookup === lookup);
};
